// extracted by mini-css-extract-plugin
export var completionBody = "_ls-2";
export var completionCard = "_ls-0";
export var completionFooter = "_ls-3";
export var completionTitle = "_ls-1";